import React from 'react';
import { createPortal } from 'react-dom';
import { Spacer } from '../../parts/Spacer';

type ButtonType = 'submit' | 'cancel' | 'warning';

export const PortalModal: React.FC<{
  title: string;
  content: React.ReactNode;
  primaryButton?: {
    type: ButtonType;
    text: string;
    onClick: (e?: unknown) => unknown;
    disabled?: boolean;
  };
  secondaryButton?: {
    type: ButtonType;
    text: string;
    onClick: (e?: unknown) => unknown;
    disabled?: boolean;
  };
}> = ({ title, content, primaryButton, secondaryButton }) => {
  const [mounted, isMounted] = React.useState<boolean>(false);

  React.useEffect(() => {
    isMounted(true);
  }, []);

  return mounted
    ? createPortal(
        <div className="fixed inset-0 z-[2000]">
          <div className="absolute inset-0 bg-main-80" />
          <div className="absolute inset-0 grid grid-cols-1 place-items-center justify-center">
            <div className="w-[calc(100%-2rem)] max-w-[28rem] rounded-3 bg-base-100">
              <div className="border-b border-b-main-10 p-4 text-h4 font-bold cst-halt leading-[1.4] text-main-100">
                {title}
              </div>
              <Spacer spacing={6} />
              <div className="px-4 text-base1 text-main-80">{content}</div>
              <Spacer spacing={8} />
              <div className="px-4 pb-4">
                <div className="flex justify-end gap-2">
                  {[secondaryButton, primaryButton].map((button, index) => (
                    <button
                      key={index}
                      onClick={button?.onClick}
                      disabled={button?.disabled ?? false}
                      type="button"
                      className={
                        button?.type === 'warning'
                          ? 'block w-fit min-w-20 appearance-none rounded-2 border-none bg-caution-primary p-3 cst-button-label-text text-base-100'
                          : button?.type === 'cancel'
                            ? 'block w-fit min-w-20 appearance-none rounded-2 border-none bg-main-40 p-3 cst-button-label-text text-base-100'
                            : 'block w-fit min-w-20 appearance-none rounded-2 border-none bg-accent-primary p-3 cst-button-label-text text-base-100'
                      }
                    >
                      {button?.text}
                    </button>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>,
        document.getElementById('modal') as Element
      )
    : null;
};
